import BaseListPresenter from "../../../../../base/BaseListPresenter";
import {
  formatCurrency,
  formattedDate,
  getMonthIndex,
} from "../../../../../components/common/Converter";
import "../../../../../components/common/TablePayrollForm.css";
import {
  getLastDayOfMonth,
  calculatetotalExcess,
  calculateTaxLaw,
  calculateApTax,
  calculatethreePercent,
  calculateTwoPercent,
  calculateFivePercent,
  calculateTenPercent,
  calculateFormattedTotal,
  calculateAmount,
  calculateAbsences,
  calculateDueAbsences,
  calculateDeducPera,
  sumList,
  calculate,
  extractSalary,
  getAPrate,
  getAugmentation,
} from "../payroll-table/calculation/PayrollCalculation.js";
import InputFactory from "../../../../../components/InputFactory";
import { v4 as uuidv4 } from "uuid";
import {
  formatDeductions,
  isUpdateNeeded,
} from "./helper-functions/PayrollHelperPage.js";
import { createNotification } from "../../../../../createNotification.js";

class PayrollTablePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  gethandleSave = async () => {
    const { contributionType, isTriggered } = this.view.state;

    const {
      csvData = [],
      data,
      additionalSelectValue,
      employmentType,
      payrollType,
      employeeID,
      startDate,
      endDate,
      selected,
    } = this.view.props;

    const individual = data.filter((item) => item.id === employeeID);
    const dataMapping =
      payrollType === "Individual Payroll"
        ? individual
        : payrollType === "J.O Salary" &&
          additionalSelectValue === "Addendum Payroll"
        ? selected
        : data;

    let csvDataMap;
    if (Array.isArray(csvData)) {
      csvDataMap = csvData.reduce((map, entry) => {
        if (entry["Agency Employee No."]) {
          map[entry["Agency Employee No."]] = entry;
        }
        return map;
      }, {});
    }

    const isContribution = contributionType.map(
      (item) => item.contributionType
    );

    const record_id = uuidv4();

    const savePromises = dataMapping.map((item) => {
      const {
        id,
        agency,
        Firstname,
        Middlename,
        surname,
        accountNumber,
        accountName,
        position,
        salaryGrade,
      } = item;

      const positionTitle = position?.position_title ?? "";
      const salary = extractSalary(salaryGrade ?? 0);

      const csvEntry =
        csvDataMap && csvDataMap[agency] ? [csvDataMap[agency]] : [];
      const concated = `(${agency ?? ""}) ${surname ?? ""} ${
        Middlename ? `${Middlename.charAt(0)}.` : ""
      } ${Firstname ?? ""}`;

      const coveragePeriod =
        startDate === "Start Date Not Selected" &&
        endDate === "End Date Not Selected"
          ? ""
          : formattedDate(startDate, endDate);

      const overpaymentBasicAmount = this.view.state.overpaymentBasic[id] || 0;
      const overpaymentPeraAmount = this.view.state.overpaymentPera[id] || 0;
      const earnedBasicAmount = this.view.state.earnedBasicTotals[id] || 0;
      const earnedPeraAmount = this.view.state.earnedPeraAdaTotals[id] || 0;
      const netPayTotal = this.view.state.netAmounts[id] || 0;
      const flagRaisingAmount = this.view.state.flagRaising[id] || 0;
      const peraAdaAmount = this.view.state.peraAda[id] || 0;
      const taxAmount = this.view.state.tax[id] || 0;
      const absenceDaysTotal = this.view.state.absenceDays[id] || 0;
      const absenceMinsTotal = this.view.state.absenceMins[id] || 0;

      const mandatoryDeduc = new Array(isContribution.length);
      const employeeMandatory = this.view.state.mandatory[id] || [];
      const earnedPeriodAmount = this.view.state.earnedForPeriod[id] || 0;
      const netAmountJOTotal = this.view.state.netAmountsJO[id] || 0;
      const taxAmountJO = this.view.state.taxJO[id] || 0;
      const basicEarned = this.view.state.basicEarning[id] || 0;
      const peraAdaEarned = this.view.state.peraAdaEarning[id] || 0;
      const proratedRate = this.view.state.proratedRate[id] || 0;
      const proratedPera = this.view.state.proratedPera[id] || 0;
      const totalBasic = this.view.state.totalBasic[id] || 0;
      const totalPera = this.view.state.totalPera[id] || 0;
      const netAmountIND = this.view.state.netAmountIND[id] || 0;
      const apRate = this.view.state.apRate[id] || 0;

      isContribution.forEach((contributionType, index) => {
        mandatoryDeduc[index] = {
          type: contributionType,
          amount: employeeMandatory[index] || "",
        };
      });

      let dataToSaved = {
        record_id: record_id,
        csvData: csvEntry,
        startDate: this.view.props.startDate,
        endDate: this.view.props.endDate,
        firstName: Firstname,
        middleName: Middlename,
        surname: surname,
        accountName: accountName,
        accountNumber: accountNumber,
      };

      switch (true) {
        case payrollType === "General Payroll" &&
          employmentType !== "Job Order" &&
          additionalSelectValue === "Basic Pay":
          dataToSaved = {
            employee_id: id,
            ...dataToSaved,
            peraAda: peraAdaAmount,
            overpaymentBasic: overpaymentBasicAmount,
            overpaymentPera: overpaymentPeraAmount,
            earnedBasic: earnedBasicAmount,
            earnedPeraAda: earnedPeraAmount,
            mandatoryDeduc: mandatoryDeduc,
            tax: taxAmount,
            netAmount: netPayTotal,
          };
          break;
        case payrollType === "General Payroll" &&
          employmentType === "Job Order" &&
          additionalSelectValue === "Basic Pay":
          dataToSaved = {
            employee_id: id,
            ...dataToSaved,
            flagRaising: flagRaisingAmount,
            overpaymentBasic: overpaymentBasicAmount,
            tax: taxAmountJO,
            absencesDays: absenceDaysTotal,
            absencesMins: absenceMinsTotal,
            earnedPeriod: earnedPeriodAmount,
            netAmount: netAmountJOTotal,
          };
          break;
        case payrollType === "General Payroll" &&
          employmentType !== "Job Order" &&
          additionalSelectValue === "Augmentation Pay":
          dataToSaved = {
            employee_id: id,
            csvData: csvEntry,
            ...dataToSaved,
            flagRaising: flagRaisingAmount,
            overpaymentBasic: overpaymentBasicAmount,
            tax: taxAmountJO,
            apRate: apRate,
          };
          break;
        case payrollType === "Addendum Payroll" &&
          employmentType !== "Job Order" &&
          additionalSelectValue === "Basic Pay":
          dataToSaved = {
            employee_id: id,
            csvData: csvEntry,
            ...dataToSaved,
            overpaymentBasic: overpaymentBasicAmount,
            overpaymentPera: overpaymentPeraAmount,
            tax: taxAmountJO,
          };
        case (payrollType === "Individual Payroll" &&
          employmentType !== "Job Order" &&
          additionalSelectValue === "Initial Salary (Basic)") ||
          additionalSelectValue === "Last Salary (Basic)":
          dataToSaved = {
            employee_id: id,
            ...dataToSaved,
            mandatoryDeduc: mandatoryDeduc,
            netAmount: netAmountIND,
            concatList: concated,
            coveragePeriod: coveragePeriod,
            position: positionTitle,
            salaryGrade: salary,
            peraAda: peraAdaAmount,
            earnedBasic: basicEarned,
            earnedPeraAda: peraAdaEarned,
            proRatedRate: proratedRate,
            proRatedPera: proratedPera,
            basic: totalBasic,
            tax: taxAmount,
            pera: totalPera,
          };
          break;
        default:
          dataToSaved = {
            employee_id: id,
            peraAda: peraAdaAmount,
            overpaymentBasic: overpaymentBasicAmount,
            overpaymentPera: overpaymentPeraAmount,
            earnedBasic: earnedBasicAmount,
            earnedPeraAda: earnedPeraAmount,
            netAmount: netPayTotal,
          };
      }

      return this.upsertUseCase.execute("payroll_table", dataToSaved);
    });

    const newContributionAmount = this.view.state.mandatory;

    const employeeRecord = dataMapping.map((employee) => {
      const employeeId = employee.id;

      const currTaxWithHeldAmount = employee.taxWithHeldAmount || 0;
      const currContributions = employee.contributionAmount || [];
      const newTaxWithHeldAmount = this.view.state.tax[employeeId] || 0;
      const newContributions = newContributionAmount[employeeId] || [];
      const totalTaxWithHeld = currTaxWithHeldAmount + newTaxWithHeldAmount;

      const contributionMap = currContributions.reduce((map, contribution) => {
        const [type, amount] = contribution.split(": ");
        map[type.trim()] = parseFloat(amount) || 0;
        return map;
      }, {});

      for (let j = 0; j < isContribution.length; j++) {
        const type = isContribution[j];
        const value = newContributions[j] || "₱ 0.00";

        const sanitizedValue =
          parseFloat(value.replace("₱ ", "").replace(/,/g, "")) || 0;

        contributionMap[type] = (contributionMap[type] || 0) + sanitizedValue;
      }

      const updatedContributions = Object.entries(contributionMap).map(
        ([type, amount]) => `${type}: ${amount.toFixed(2)}`
      );

      const payrollRecord = {
        id: employeeId,
        taxWithHeldAmount: totalTaxWithHeld,
        contributionAmount: updatedContributions,
        payrollMonth: new Date().toLocaleString("default", { month: "long" }),
        payrollYear: new Date().getFullYear().toString(),
      };

      return this.upsertUseCase.execute("employees", payrollRecord);
    });

    await Promise.all([...savePromises, ...employeeRecord]);

    const employeeIds = dataMapping.map((item) => item.id);
    const employeePayrollData = {
      id: record_id,
      startDate: this.view.props.startDate,
      endDate: this.view.props.endDate,
      payrollType: payrollType,
      employmentType: employmentType,
      payrollTemplate: additionalSelectValue,
      employee: employeeIds,
      stats: isTriggered ? "Printed" : "Pending",
    };

    await this.upsertUseCase.execute("employee_payroll", employeePayrollData);

    //  CREATE NOTIFICATION
    const NOTIFICATION_MESSAGE = "Your latest Payslip is now available.";
    const NOTIFICATION_RECEIVER = ["role:user"];
    const NOTIFICATION_REDIRECT = "payslip";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT
    );

    if (!isTriggered) {
      localStorage.setItem("payrollName", this.view.state.name);
      localStorage.setItem("payrollPosition", this.view.state.position);
      this.view.showSuccess("Data Saved Successfully!");
      this.view.props.refetchData();
      this.view.props.closeAccess();
    }
  };

  handleChange(key, id, value) {
    this.view.setState((prevState) => ({
      [key]: {
        ...prevState[key],
        [id]: value,
      },
    }));
  }

  onchangeBasic(id, value) {
    this.handleChange("overpaymentBasic", id, value);
  }
  onchangePera(id, value) {
    this.handleChange("overpaymentPera", id, value);
  }
  onchangeFlag(id, value) {
    this.handleChange("flagRaising", id, value);
  }
  onchangePeraAda(id, value) {
    this.handleChange("peraAda", id, value);
  }
  onchangeNoOfDuties(id, value) {
    this.handleChange("noOfDuties", id, value);
  }

  getrenderBody = (params) => {
    const {
      fields = [],
      csvData,
      otherDeductionType,
      otherAdditionalType,
      allowancesHeader,
      additionalHeader,
      data,
      employeesMins,
      headerCount,
      contributions,
      contributionList,
      isGraduated,
      isSubmitted,
      twentyFourSeven,
      extractedSalaries,
      extractedAprate,
      taxTableList,
      allowanceList,
      absences,
      counts,
      positionLevel,
    } = params;

    const {
      overpaymentBasic,
      overpaymentPera,
      numberofDays,
      totalDaysDeduc,
      peraAda,
      flagRaising,
      noOfDuties,
      date,
    } = this.view.state;
    const {
      startDate,
      endDate,
      payrollType,
      employmentType,
      additionalSelectValue,
      employeeID,
      holidaysCount,
      workingDaysCount,
      weekEndsOff,
      payrollCode,
      selected,
      lateUndertimeMins,
      airportAssignDays,
    } = this.view.props;

    const monthIndex = getMonthIndex(startDate, endDate);

    const arrayFields = [
      "OtherDeduction",
      "OtherAdditional",
      "importedData",
      "importedAdditional",
      "contributions",
    ];

    const individual = data.filter((item) => item.id === employeeID);
    const dataMapping =
      payrollType === "Individual Payroll"
        ? selected
        : payrollType === "J.O Salary" &&
          additionalSelectValue === "Addendum Payroll"
        ? selected
        : data;

    const validCsvData = Array.isArray(csvData) ? csvData.flat() : [];
    const validOtherDeductionType = otherDeductionType ?? [];
    const validOtherAdditionalType = otherAdditionalType ?? [];
    const validAllowancesType = allowancesHeader ?? [];
    const validAdditionalHead = additionalHeader ?? [];

    const validContributionType =
      contributions?.map((item) => item.contributionType) ?? [];

    const updatedData = dataMapping.map((employee) => {
      const matchedEmployeeMins = employeesMins.find(
        (mins) => mins.id === employee.id
      );
      const minstobeDeduc = matchedEmployeeMins
        ? matchedEmployeeMins.totalMinsDeducted
        : 0;

      return {
        minstobeDeduc,
      };
    });

    const minstobeDeduc = updatedData.map((item) => item.minstobeDeduc);
    const lastDayOfMonth = getLastDayOfMonth();

    if (fields && dataMapping && dataMapping.length > 0) {
      return dataMapping.map((item, rowIndex) => {
        const matchingCsvEntry = validCsvData.find((csvItem) => {
          if (!csvItem) return false;
          const agencyEmployeeNo = csvItem["Agency Employee No."];
          return (
            agencyEmployeeNo && agencyEmployeeNo.trim() === String(item.agency)
          );
        });

        const totalOtherDeductions = calculateFormattedTotal(
          validOtherDeductionType,
          matchingCsvEntry
        );

        const totalOtherAdditional = calculateFormattedTotal(
          validOtherAdditionalType,
          matchingCsvEntry
        );
        const totalIncentiveDeduc = calculateFormattedTotal(
          validAllowancesType,
          matchingCsvEntry
        );
        const totalIncentiveAdd = calculateFormattedTotal(
          validAdditionalHead,
          matchingCsvEntry
        );

        // Basic Pay (Organic, Coterminus, Contractual)
        const earnedBasicTotal = calculate(extractedSalaries[rowIndex], [
          { type: "subtract", value: overpaymentBasic[item.id] },
        ]);

        const earnedPeraAdaTotal = calculate(peraAda[item.id], [
          { type: "subtract", value: overpaymentPera[item.id] },
        ]);

        const apRateAmount = getAPrate(extractedAprate[rowIndex]);

        const employeeContributions = contributionList.filter(
          (contribution) => contribution.email === item.email
        );

        const contributionMap = employeeContributions.reduce(
          (acc, contribution) => {
            acc[contribution.contribution.toLowerCase()] = contribution.amount;
            return acc;
          },
          {}
        );

        const contributionData = validContributionType.map((typeKey, j) => {
          let amount = contributionMap[typeKey.toLowerCase()] || "";

          const contributionDetails = contributions.find(
            (item) => item.contributionType === typeKey
          );

          const roundUp = contributionDetails?.roundUp || false;
          const roundDown = contributionDetails?.roundDown || false;

          const salaryGrade = extractedSalaries[rowIndex];
          if (
            typeof amount === "string" &&
            amount.includes("monthly_rate") &&
            salaryGrade
          ) {
            amount = calculateAmount(amount, salaryGrade);
            amount = amount ? amount : "";
          }

          const formattedAmount = roundUp
            ? formatCurrency(amount.toString())
            : roundDown
            ? ` ${(Math.floor(amount * 100) / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            : formatCurrency(amount.toString());
          return formattedAmount;
        });

        const convertedAmounts = contributionData.map((amount) => {
          return amount && amount !== "-"
            ? parseFloat(amount.toString().replace(/[^\d.-]/g, ""))
            : 0;
        });

        const totalContribution = parseFloat(sumList(convertedAmounts));

        const taxLawTotal = calculateTaxLaw(
          monthIndex,
          extractedSalaries[rowIndex],
          taxTableList,
          item,
          allowanceList,
          totalContribution
        );

        console.log("taxLawTotal", taxLawTotal);

        const apTaxLawTotal = calculateApTax(
          monthIndex,
          item?.payCode,
          taxTableList,
          taxLawTotal?.totalAllowances,
          taxLawTotal?.taxOnExcess,
          taxLawTotal?.salary
        );
        const num = 13875;

        const netAmount = calculate(earnedBasicTotal, [
          { type: "add", value: earnedPeraAdaTotal },
          {
            type: "subtract",
            value:
              taxLawTotal?.totalTax +
              totalContribution +
              (parseFloat(totalOtherDeductions) || 0) +
              (parseFloat(totalOtherAdditional) || 0),
          },
        ]);
        // Basic Pay (Job Order)
        const absencesDays = calculate(totalDaysDeduc, [
          { type: "multiply", value: extractedSalaries[rowIndex] },
          { type: "divide", value: numberofDays },
        ]);

        const absencesMins = calculate(minstobeDeduc[rowIndex], [
          { type: "multiply", value: extractedSalaries[rowIndex] },
          { type: "divide", value: numberofDays },
          { type: "divide", value: twentyFourSeven[rowIndex] },
          { type: "divide", value: 60 },
        ]);

        const earnedPeriod = calculate(extractedSalaries[rowIndex], [
          {
            type: "subtract",
            value:
              absencesDays +
              absencesMins +
              overpaymentBasic[item.id] +
              flagRaising[item.id],
          },
        ]);

        const totralTaxJO = calculatetotalExcess(
          extractedSalaries[rowIndex],
          allowanceList,
          item
        );

        const threePercentJO = calculatethreePercent(
          isGraduated[rowIndex],
          extractedSalaries[rowIndex]
        );
        const twoPercentJO = calculateTwoPercent(
          isSubmitted[rowIndex],
          extractedSalaries[rowIndex],
          totralTaxJO[item.id]
        );
        const fivePercentJO = calculateFivePercent(
          isSubmitted[rowIndex],
          extractedSalaries[rowIndex],
          totralTaxJO[item.id]
        );
        const tenPercentJO = calculateTenPercent(
          isSubmitted[rowIndex],
          totralTaxJO[item.id]
        );

        const totalTax = calculate(0, [
          { type: "add", value: threePercentJO },
          { type: "add", value: twoPercentJO },
          { type: "add", value: fivePercentJO },
          { type: "add", value: tenPercentJO },
        ]);

        const totalNetPay = calculate(earnedPeriod, [
          { type: "subtract", value: totalTax },
          {
            type: "subtract",
            value: totalOtherDeductions + totalOtherAdditional,
          },
        ]);

        const addAbsence = calculateAbsences(absences[rowIndex]);

        const insuredDays = calculate(lastDayOfMonth, [
          { type: "subtract", value: addAbsence },
        ]);

        const dueToLeaves = calculateDueAbsences(
          addAbsence,
          extractedSalaries[rowIndex],
          counts[item.id],
          minstobeDeduc[rowIndex]
        );

        const deducPeraAda = calculateDeducPera(
          addAbsence,
          peraAda[item.id],
          counts[item.id],
          minstobeDeduc[rowIndex]
        );

        const earnedBasicAdd = calculate(extractedSalaries[rowIndex], [
          { type: "subtract", value: dueToLeaves },
          { type: "subtract", value: overpaymentBasic[item.id] },
        ]);

        const earnedPeraAdd = calculate(peraAda[item.id], [
          { type: "subtract", value: deducPeraAda },
          { type: "subtract", value: overpaymentPera[item.id] },
        ]);

        const netPayAdd = calculate(earnedBasicAdd, [
          { type: "add", value: earnedPeraAdd },
          {
            type: "subtract",
            value:
              taxLawTotal?.totalTax +
              totalContribution +
              (parseFloat(totalOtherDeductions) || 0) +
              (parseFloat(totalOtherAdditional) || 0),
          },
        ]);

        const perDayFirst = calculate(extractedSalaries[rowIndex], [
          { type: "divide", value: 22 },
        ]);
        const perMinuteFirst = calculate(extractedSalaries[rowIndex], [
          { type: "divide", value: 22 },
          { type: "divide", value: 8 },
          { type: "divide", value: 60 },
        ]);
        const perDaySecond = calculate(2000, [{ type: "divide", value: 22 }]);
        const perMinSecond = calculate(2000, [
          { type: "divide", value: 22 },
          { type: "divide", value: 8 },
          { type: "divide", value: 60 },
        ]);

        const inService = calculate(workingDaysCount, [
          { type: "subtract", value: holidaysCount },
        ]);

        const proRatedRate = calculate(extractedSalaries[rowIndex], [
          { type: "multiply", value: inService },
          { type: "divide", value: 22 },
        ]);

        const proRatedPera = calculate(peraAda[item.id], [
          { type: "multiply", value: inService },
          { type: "divide", value: 22 },
        ]);

        const excludedDays = calculate(weekEndsOff, [
          { type: "add", value: holidaysCount },
        ]);

        const daySecond = calculate(addAbsence, [
          { type: "multiply", value: perDayFirst },
        ]);
        const minSecond = calculate(minstobeDeduc[rowIndex], [
          { type: "multiply", value: perMinuteFirst },
        ]);
        const basic = calculate(0, [
          { type: "add", value: daySecond },
          { type: "add", value: minSecond },
        ]);
        const dayThird = calculate(addAbsence, [
          { type: "multiply", value: perDaySecond },
        ]);
        const minThird = calculate(minstobeDeduc[rowIndex], [
          { type: "multiply", value: perMinSecond },
        ]);
        const pera = calculate(0, [
          { type: "add", value: dayThird },
          { type: "add", value: minThird },
        ]);
        const daysForGsis = calculate(0, [
          { type: "add", value: inService },
          { type: "add", value: excludedDays },
        ]);
        const basicEarned = calculate(proRatedRate, [
          { type: "subtract", value: basic },
        ]);
        const peraAdaEarned = calculate(proRatedPera, [
          { type: "subtract", value: pera },
        ]);
        const total = calculate(0, [
          { type: "add", value: basicEarned },
          { type: "add", value: peraAdaEarned },
        ]);

        const dailyRateAP = calculate(extractedSalaries[rowIndex], [
          { type: "divide", value: 22 },
        ]);
        const perMinAP = calculate(extractedSalaries[rowIndex], [
          { type: "divide", value: 22 },
          { type: "divide", value: 10.5 },
          { type: "divide", value: 60 },
        ]);
        const latesUTAP = calculate(perMinAP, [
          { type: "multiply", value: minstobeDeduc[rowIndex] },
        ]);

        const individualNetPay = calculate(total, [
          { type: "subtract", value: totalContribution },
        ]);

        const earnedForPeriodAP = calculate(dailyRateAP, [
          { type: "multiply", value: workingDaysCount },
          { type: "subtract", value: latesUTAP },
        ]);

        const netPayIncentives = calculate(extractedSalaries[rowIndex], [
          { type: "subtract", value: parseFloat(totalIncentiveDeduc) || 0 },
          { type: "add", value: parseFloat(totalIncentiveAdd) || 0 },
        ]);

        const proRated = calculate(noOfDuties[item.id], [
          { type: "subtract", value: airportAssignDays[item.id] },
          { type: "multiply", value: item.payCode },
          { type: "divide", value: noOfDuties[item.id] },
        ]);

        const lateUtCurrentAss = calculate(item?.payCode, [
          { type: "divide", value: noOfDuties[item.id] },
          { type: "divide", value: 12 },
          { type: "divide", value: 60 },
          { type: "multiply", value: lateUndertimeMins[item?.id] },
        ]);

        const earnedCurrAss = calculate(proRated, [
          { type: "subtract", value: 0 },
          { type: "subtract", value: lateUtCurrentAss },
        ]);

        const airportAugRate = airportAssignDays.hasOwnProperty(item?.id)
          ? 50000
          : 0;

        const airportAmountEarned = calculate(airportAugRate, [
          { type: "divide", value: 22 },
          { type: "multiply", value: airportAssignDays[item.id] },
        ]);

        const earnedAirportDuties = calculate(airportAmountEarned, [
          { type: "subtract", value: 0 },
          { type: "subtract", value: 0 },
        ]);

        const totalEarned = calculate(earnedCurrAss, [
          { type: "add", value: earnedAirportDuties },
          { type: "add", value: 0 },
        ]);

        const netEarned = calculate(totalEarned, [
          { type: "subtract", value: overpaymentBasic[item.id] },
          { type: "subtract", value: flagRaising[item.id] },
        ]);

        const netAmountAP = calculate(netEarned, [
          { type: "subtract", value: apTaxLawTotal },
          { type: "subtract", value: totalContribution },
        ]);

        // const getAugmentationRATE = getAugmentation(payrollCode, item.payCode);

        // const netPayAP = calculate(earnedForPeriodAP, [
        //   { type: "subtract", value:  },
        // ]);

        const getStateValue = (field, id) => this.view.state[field][id] || 0;

        const fieldsToUpdate = [
          {
            field: "earnedBasicTotals",
            newValue:
              payrollType === "Addendum Payroll" &&
              employmentType !== "Job Order" &&
              additionalSelectValue === "Basic Pay"
                ? earnedBasicAdd
                : earnedBasicTotal,
          },
          {
            field: "earnedPeraAdaTotals",
            newValue: earnedPeraAdaTotal,
          },
          {
            field: "netAmounts",
            newValue: netAmount,
          },
          {
            field: "tax",
            newValue: taxLawTotal?.totalTax ?? 0,
          },
          {
            field: "mandatory",
            newValue: contributionData,
            isArray: true,
          },
          {
            field: "absenceDays",
            newValue: absencesDays,
          },
          {
            field: "absenceMins",
            newValue: absencesMins,
          },
          {
            field: "earnedForPeriod",
            newValue: earnedPeriod,
          },
          {
            field: "netAmountsJO",
            newValue: totalNetPay,
          },
          {
            field: "taxJO",
            newValue: totalTax,
          },
          {
            field: "basicEarning",
            newValue: basicEarned,
          },
          {
            field: "peraAdaEarning",
            newValue: peraAdaEarned,
          },
          {
            field: "proratedRate",
            newValue: proRatedRate,
          },
          {
            field: "proratedPera",
            newValue: proRatedPera,
          },
          {
            field: "totalBasic",
            newValue: basic,
          },
          {
            field: "totalPera",
            newValue: pera,
          },
          {
            field: "netAmountIND",
            newValue: individualNetPay,
          },
          {
            field: "apRate",
            newValue: apRateAmount,
          },
        ];

        const updatedFields = fieldsToUpdate.reduce(
          (updates, { field, newValue, isArray }) => {
            const currValue = getStateValue(field, item.id);
            if (isUpdateNeeded({ newValue, currValue, isArray })) {
              updates[field] = {
                ...this.view.state[field],
                [item.id]: newValue,
              };
            }
            return updates;
          },
          {}
        );

        if (Object.keys(updatedFields).length > 0) {
          this.view.setState((prevState) => ({
            ...prevState,
            ...updatedFields,
          }));
        }

        const columnData = {
          increment: () => rowIndex + 1,
          salaryGrade: () =>
            formatCurrency((extractedSalaries[rowIndex] ?? 0).toString()),
          noOfDays: () => numberofDays,
          daystobeDeduc: () => addAbsence,
          gsisInsuredDays: () => insuredDays,
          absencesDays: () => formatCurrency(absencesDays.toString()),
          earnedPeriod: () => formatCurrency(earnedPeriod.toString()),
          absencesMins: () => formatCurrency(absencesMins.toString()),
          threePercent: () => formatCurrency(threePercentJO.toString()),
          twoPercent: () => formatCurrency(twoPercentJO.toString()),
          fivePercent: () => formatCurrency(fivePercentJO.toString()),
          tenPercent: () => formatCurrency(tenPercentJO.toString()),
          totalTax: () => formatCurrency(totalTax.toString()),
          netAmountsJO: () => formatCurrency(totalNetPay.toString()),
          tax: () => formatCurrency((taxLawTotal?.totalTax ?? 0).toString()),
          taxAP: () =>
            item?.id === "322b2d97-a168-400d-afc8-13deb5468797"
              ? formatCurrency(num.toString())
              : formatCurrency(apTaxLawTotal.toString()),
          minsToBeDeducted: () => minstobeDeduc[rowIndex],
          halfDaystoDeduc: () => counts[item.id],
          dueToAbsence: () => dueToLeaves,
          deducPera: () => deducPeraAda,
          daysInAMonth: () => lastDayOfMonth,
          dayFirst: () => addAbsence,
          minFirst: () => minstobeDeduc[rowIndex],

          earnedBasic: () =>
            payrollType === "Addendum Payroll"
              ? formatCurrency(earnedBasicAdd.toString())
              : formatCurrency(earnedBasicTotal.toString()),
          earnedPeraAda: () =>
            payrollType === "Addendum Payroll"
              ? formatCurrency(earnedPeraAdd.toString())
              : formatCurrency(earnedPeraAdaTotal.toString()),
          netAmount: () =>
            payrollType === "Addendum Payroll"
              ? formatCurrency(netPayAdd.toString())
              : formatCurrency(netAmount.toString()),
          employmentStats: () => employmentType,
          concatList: () =>
            `(${item?.agency ?? ""}) ${item?.surname ?? ""} ${
              item?.Middlename ? `${item.Middlename.charAt(0)}.` : ""
            } ${item?.Firstname ?? ""}`,
          coverage: () =>
            startDate === "Start Date Not Selected" &&
            endDate === "End Date Not Selected"
              ? ""
              : formattedDate(startDate, endDate),

          plantillaItem: () => positionLevel,
          perDayFirst: () => perDayFirst,
          perMinFirst: () => perMinuteFirst,
          perDaySecond: () => perDaySecond,
          perMinSecond: () => perMinSecond,
          inService: () => Math.max(0, inService),
          date: () => date,
          proratedRate: () => proRatedRate,
          proratedPera: () => proRatedPera,
          weekends: () => excludedDays,
          daySecond: () => daySecond,
          minSecond: () => minSecond,
          basic: () => basic,
          dayThird: () => dayThird,
          minThird: () => minThird,
          pera: () => pera,
          daysForGSIS: () => daysForGsis,
          basicEarned: () => basicEarned,
          peraAdaEarned: () => peraAdaEarned,
          total: () => total,
          individualNetPay: () => individualNetPay,
          dailyRate: () => dailyRateAP,
          perMinute: () => perMinAP,
          latesIncurred: () => minstobeDeduc[rowIndex],
          latesUT: () => latesUTAP,
          daysEarned: () => workingDaysCount,
          earnedForPeriodAP: () => formatCurrency(earnedForPeriodAP.toString()),
          netPayIncentive: () => formatCurrency(netPayIncentives.toString()),
          apRate: () => formatCurrency((item?.payCode ?? 0).toString()),
          utPerMinute: () => lateUtCurrentAss,
          latesUndertimeMins: () => lateUndertimeMins[item?.id],
          noOfDuties: () => airportAssignDays[item?.id],
          absencesPresent: () => 0,
          absencesLeaves: () => 0,
          absencesAugmentation: () => 0,
          totalDuty: () => noOfDuties[item.id] || 0,
          prorated: () => formatCurrency(proRated.toString()),
          currentAssign: () => formatCurrency(earnedCurrAss.toString()),
          airportApRate: () => formatCurrency(airportAugRate.toString()),
          amountEarnedAP: () => formatCurrency(airportAmountEarned.toString()),
          airportDuties: () => formatCurrency(earnedAirportDuties.toString()),
          totalEarned: () => formatCurrency(totalEarned.toString()),
          earnedAp: () => formatCurrency(netEarned.toString()),
          netAmountAP: () => formatCurrency(netAmountAP.toString()),

          daysTobeDeduc: () => 0,
          halfDaysTobeDeduc: () => 0,
          minutesTobeDeduc: () => 0,

          overpaymentBasic: () => (
            <InputFactory
              className="custom-input"
              type="Number"
              field="overpaymentBasic"
              value={overpaymentBasic[item.id] || ""}
              onChange={(value) => this.onchangeBasic(item.id, value)}
            />
          ),
          overpaymentPeraAda: () => (
            <InputFactory
              className="custom-input"
              type="Number"
              field="overpaymentPera"
              value={overpaymentPera[item.id] || ""}
              onChange={(value) => this.onchangePera(item.id, value)}
            />
          ),
          peraAda: () => (
            <InputFactory
              className="custom-input custom"
              type="Number"
              field="peraAda"
              value={peraAda[item.id] || ""}
              onChange={(value) => this.onchangePeraAda(item.id, value)}
            />
          ),
          flagRaising: () => (
            <InputFactory
              className="custom-input"
              type="Number"
              field="flagRaising"
              value={flagRaising[item.id] || ""}
              onChange={(value) => this.onchangeFlag(item.id, value)}
            />
          ),
          duties: () => (
            <InputFactory
              className="custom-input"
              type="Number"
              field="noOfDuties"
              value={noOfDuties[item.id] || ""}
              onChange={(value) => this.onchangeNoOfDuties(item.id, value)}
            />
          ),
          OtherDeduction: () =>
            formatDeductions(
              "deduction",
              validOtherDeductionType,
              rowIndex,
              matchingCsvEntry
            ),

          OtherAdditional: () =>
            formatDeductions(
              "additional",
              validOtherAdditionalType,
              rowIndex,
              matchingCsvEntry
            ),

          importedData: () =>
            formatDeductions(
              "allowances",
              validAllowancesType,
              rowIndex,
              matchingCsvEntry
            ),
          importedAdditional: () =>
            formatDeductions(
              "additionals",
              validAdditionalHead,
              rowIndex,
              matchingCsvEntry
            ),
          contributions: () =>
            contributionData.map((formattedAmount, j) => (
              <td key={`contribution-${rowIndex}-${j}`}>{formattedAmount}</td>
            )),
        };

        return (
          <tr key={rowIndex}>
            {Array.isArray(fields) &&
              fields.map((field, i) => {
                if (columnData[field]) {
                  return arrayFields.includes(field) ? (
                    columnData[field]()
                  ) : (
                    <td key={`${field}-${rowIndex}`}>{columnData[field]()}</td>
                  );
                }
                return <td key={i}>{item?.[field] ?? "-"}</td>;
              })}
          </tr>
        );
      });
    }

    return (
      <tr>
        <td colSpan={headerCount} className="no-data" id="no-data">
          <img src={"/noData.svg"} alt="No Data" className="no-data-img" />
          <p>No Data</p>
        </td>
      </tr>
    );
  };
}

export default PayrollTablePresenter;
